import { render, staticRenderFns } from "./EditOrder.vue?vue&type=template&id=4936814c&lang=pug&"
import script from "./EditOrder.vue?vue&type=script&lang=ts&"
export * from "./EditOrder.vue?vue&type=script&lang=ts&"
import style0 from "./EditOrder.vue?vue&type=style&index=0&id=4936814c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports